import { ApiProperty } from "@nestjs/swagger";

export class ProductInspectionSamplesDTO{
    @ApiProperty()
    inspectionSampleId:number;

    @ApiProperty()
    inspectionId:number

    @ApiProperty()
    time:Date

    @ApiProperty()
    sampleNo: number;
  
    @ApiProperty()
    temperature: number;

    @ApiProperty()
    fillingWeight: number;

    @ApiProperty()
    frozenWeight: number;

    @ApiProperty()
    deglazedWeight: number;

    @ApiProperty()
    netWeight: number;

    @ApiProperty()
    subSampleWeight: number;

    @ApiProperty()
    frozenCount: number;

    @ApiProperty()
    deglazedCount: number;

    @ApiProperty()
    netCount: number;

    @ApiProperty()
    totalPieces: number;

    @ApiProperty()
    glazePercent: number;

    @ApiProperty()
    totalOunce: number;

    @ApiProperty()
    cluster: string;

    @ApiProperty()
    generalAppearance: string;

    @ApiProperty()
    generalOdour: string;

    @ApiProperty()
    freshness: string;

    @ApiProperty()
    texture: string;

    @ApiProperty()
    dehydration: string;

    @ApiProperty()
    discoloration: string;

    @ApiProperty()
    deterioration: string;

    @ApiProperty()
    peeling: string;

    @ApiProperty()
    hangingMeat: string;

    @ApiProperty()
    blackSpot: string;

    @ApiProperty()
    broken: string;

    @ApiProperty()
    wrongCut: string;

    @ApiProperty()
    shells: string;

    @ApiProperty()
    foreignMatter: string;

    @ApiProperty()
    uniformityBig: number;

    @ApiProperty()
    uniformitySmall: number;

    @ApiProperty()
    uniformityRatio: number;

    @ApiProperty()
    productMetSpec: number;

    @ApiProperty()
    bestBefore: Date;

    @ApiProperty()
    remarks: string;

    
    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    versionFlag: number;
}